import { render, staticRenderFns } from "./EnquiryReservationsTable.vue?vue&type=template&id=60617a5e&"
import script from "./EnquiryReservationsTable.vue?vue&type=script&lang=js&"
export * from "./EnquiryReservationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports